<div *ngIf="showTour" class="tour-overlay">
  <div #maskEl class="tour-mask" [ngStyle]="maskStyle"></div>
  <div #descEl class="tour-description" [ngStyle]="descStyle" [style.opacity]="descVisible ? 1 : 0">
    <p class="stepsCont">Step {{ stepIndex + 1 }} of {{ steps.length }}</p>
    <h2 *ngIf="topic">{{ topic ? topic : '' }}</h2>
    <p *ngIf="description" class="desc">{{ description ? description : '' }}</p>
    <div class="ctaCont">
      <label for="dontShowThisAgain">
        <input type="checkbox" id="dontShowThisAgain" [(ngModel)]="dontShowAgain" />
        Don't show this again
      </label>
      <div class="rightBlock">
        <button *ngIf="!isLastStep()" (click)="skipTour()" class="secondary.link">Skip</button>
        <button *ngIf="!isLastStep()" (click)="nextStep()" [disabled]="!elementFound" class="primary">Next</button>
        <button *ngIf="isLastStep()" (click)="doneTour()" class="primary">Done</button>
        <!-- <button (click)="endTour()">End Tour</button> -->
      </div>
    </div>
  </div>
</div>

<!-- <app-success-toast *ngIf="successMsg" [message]="successMsg" ></app-success-toast> -->
<!-- <app-error-toast *ngIf="errorMsg" [message]="error" ></app-error-toast> -->
